<template>
  <H5Layout title="循环录音" active="meeting">
    <AMeetingLoop></AMeetingLoop>
  </H5Layout>
</template>

<script>
import H5Layout from "./H5Layout.vue";
import AMeetingLoop from "@/vue_views/AMeetingLoop.vue";

export default {
  name: "MeetingH5Loop",
  components: {
    H5Layout,
    AMeetingLoop
  }
}
</script>

<style>
/* 循环模式 H5 适配：textarea 固定高度、按钮区允许换行、紧凑间距 */
.h5-layout .Meeting-container > div[style*="height: 150px"] {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
}

.h5-layout .Meeting-container textarea {
  flex: none;
  height: 14vh !important;
  min-height: 80px !important;
  max-height: 14vh !important;
}

/* 主按钮区：按钮一行均分，静音输入框放不下时换到第二行完整显示 */
.h5-layout .Meeting-container div[style*="margin-top:100px"] {
  flex-wrap: wrap !important;
  margin-top: 0 !important;
  gap: 6px;
  padding: 4px 0 calc(4px + env(safe-area-inset-bottom)) 0;
}

.h5-layout .Meeting-container div[style*="margin-top:100px"] .el-button {
  flex: 1 1 calc(33% - 4px) !important;
  min-width: 0 !important;
  padding: 8px 2px !important;
  margin: 0 !important;
}

.h5-layout .Meeting-container div[style*="margin-top:100px"] .el-button span {
  font-size: 13px;
  white-space: nowrap;
}

/* 静音输入框：不参与按钮均分，紧凑展示 */
.h5-layout .Meeting-container div[style*="margin-top:100px"] .vad-eos-label {
  flex-shrink: 0 !important;
  font-size: 12px !important;
  margin: 0 2px !important;
}

.h5-layout .Meeting-container div[style*="margin-top:100px"] .vad-eos-input {
  flex-shrink: 0 !important;
  width: 90px !important;
}

/* 材长行：上传录音 + 材长 + 查看统计 单行展示 */
.h5-layout .Meeting-container .wood-len-row {
  flex-wrap: nowrap !important;
  gap: 6px;
  padding: 2px 0 calc(4px + env(safe-area-inset-bottom)) 0;
}

.h5-layout .Meeting-container .wood-len-row .el-button {
  padding: 6px 8px !important;
  font-size: 12px;
  white-space: nowrap;
}

.h5-layout .Meeting-container .wood-len-row .wood-len-input {
  width: 100px;
}
</style>
